import { Injectable } from '@angular/core';
import { AmplifyApiService } from "@nx/amplify-api";
import { AwsAuthService } from '@nx/auth';
import { Observable } from 'rxjs';
import { ClientMetadata } from 'libs/auth/src/lib/interfaces/client-meta-data.interface';
import { LmwUserExists } from '../../registration/interfaces/lmw-user-exists.interface';


@Injectable({
  providedIn: 'root'
})
export class AuthProcessService {

  constructor(private amplifyApiService: AmplifyApiService, private awsAuthService: AwsAuthService) { }

  public setCursorToEndOfInput(inputID) {
    const inputField = (<HTMLInputElement>document.getElementById(inputID));
    const valueLength = inputField.value.length * 2;
    inputField.focus();
    setTimeout(function () {
      inputField.setSelectionRange(valueLength, valueLength);
    }, 0);
  }

  public login(signInAttribute: string, password: string, clientMetaData?: ClientMetadata): Observable<any> {
    return this.awsAuthService.login(signInAttribute, password, clientMetaData);
  }

  public logout() {
    return this.awsAuthService.logout();
  }

  public checkUserExists(signInCredential:string): Observable<LmwUserExists> {
    return this.amplifyApiService.publicGet(`/core-new/check-user-exists/${signInCredential}`)
  };

}
